<script>
import ElTimeline from 'element-ui/packages/timeline/src/main'

export default {
  name: 'ElTimeline',
  extends: ElTimeline,
  props: {
    compact: { type: Boolean, default: false }
  },
  render (h) {
    const vnode = ElTimeline.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-timeline', { 'ui-timeline--compact': this.compact }]
    return vnode
  }
}
</script>
